import React from "react";
import homeBanner from "../assets/home_banner.png";
import overvalue from "../assets/adbout-img.png";
import workers from "../assets/home_why_choose_us.png";
import slider1 from "../assets/slider1.jpg";
import slider2 from "../assets/slider2.jpg";
import slider3 from "../assets/slider3.jpg";
import slider4 from "../assets/slider4.jpg";
import slider5 from "../assets/slider5.jpg";
import slider6 from "../assets/slider6.jpg";
import slider7 from "../assets/slider7.jpg";
import slider8 from "../assets/slider8.jpg";
import getInTouch from "../assets/getintouch.png";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import bulidingBg from "../assets/completion-rate-ing.png";
import check from "../assets/check.png";
import { gsap } from "gsap";
import { useEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import pdf from "../assets/projects.pdf";

function Home() {
  const sliderImages = [
    slider1,
    slider2,
    slider3,
    slider4,
    slider5,
    slider6,
    slider7,
    slider8,
  ];

  useEffect(() => {
    var tl = gsap.timeline({ paused: true });

    tl.fromTo(".img-holder ", { xPercent: 100 }, { duration: 1.2, xPercent: 0 })
      .fromTo(
        ".img-holder  img",
        { xPercent: -100 },
        { duration: 1.2, xPercent: 0 },
        "<"
      )
      .play();

    gsap.registerPlugin(ScrollTrigger);

    const counters = gsap.utils.toArray(".counter"); // selects all counters

    counters.forEach((counter) => {
      let targetValue = parseInt(counter.getAttribute("data-target"), 10);

      gsap.fromTo(
        counter,
        { innerText: 0 },
        {
          innerText: targetValue,
          duration: 2,
          scrollTrigger: {
            trigger: counter,
            start: "top 80%",
          },
          snap: { innerText: 1 },
          ease: "power1.out",
          onUpdate: function () {
            counter.innerText = Math.round(counter.innerText) + "%";
          },
        }
      );
    });
  }, []);

  return (
    <div className="font-sans text-gray-800">
      <Header />
      <section className="flex flex-col md:flex-row bg-[#EBEDF2] flex-wrap">
        <div className="w-full md:w-1/2 home-content">
          <h1 data-aos="fade-up" className="home-content-heading">
            Welcome to <br />
            <span>Bhagwati Engineering</span>
            <br />
            Contractors
          </h1>

          <div className="flex gap-4 mt-10">
            <Link to="/contact">
              <button
                data-aos="fade-up"
                data-aos-delay="700"
                className="bg-blue-900 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-800 transition"
              >
                GET A QUOTE
              </button>
            </Link>
            <a target="_blank" download={true} href={pdf}>
              <button
                data-aos="fade-up"
                data-aos-delay="750"
                className="bg-gray-300 text-black px-6 py-3 rounded-full font-medium hover:bg-gray-400 transition"
              >
               OUR PROJECTS
              </button>
            </a>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2">
          <div class="wrapper-img">
            <div className="img-holder">
              <img
                src={homeBanner}
                alt="Construction Site"
                className="w-full h-full object-cover cons-img"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#153280] text-white px-6 xl:px-16 gap-4 flex-wrap  lg:px-12 py-20">
        <div className="home-aboutus-content">
          {/* Left Section */}
          <div className="aboutus-content">
            <p data-aos="fade-up" className="abouat-ara">
              About Us
            </p>
            <h2 data-aos="fade-up">
              Building Mumbai’s <br /> Skyline Since 2017
            </h2>
            <Link to="/about">
              <button data-aos="fade-up" className="aboutus-btn">
                View More
              </button>
            </Link>
          </div>

          {/* Right Section */}
          <div className="aboutus-content-para">
            <p data-aos="fade-up">
              We are Bhagwati Engineering construction partners who bring
              structure to your vision and stability to your dreams. Established
              in 2017, we are known for our precision in execution, project
              management, and compliance, with an extensive portfolio of
              residential, commercial, and redevelopment projects across Mumbai.
            </p>
          </div>
        </div>

        <div className="flex about-home-cards">
          <div className="bg-[#236CF6] rounded-xl">
            <div className="card-content-1">
              <img
                data-aos="fade-up"
                src={bulidingBg}
                alt="Building"
                className="h-16 w-16 object-contain"
              />
              <p>Completion Rate</p>
              <span className="counter" data-target="100">
                0%
              </span>
            </div>
          </div>

          <div className="main-cards flex flex-col gap-10">
            <div className="bg-[#A7C5FB] text-black p-6 rounded-xl flex flex-col justify-center card-content-2">
              <div>
                <p>Client Satisfaction</p>
                <span className="counter" data-target="99">
                  0%
                </span>
              </div>
            </div>

            <div className="bg-[#FFFFFF] text-black p-6 rounded-xl flex flex-col justify-center card-content-2">
              <div>
                <p>Cost Efficiency</p>
                <span data-aos="fade-up" className="countesr">
                  Tailored for Impact
                </span>
              </div>
            </div>
          </div>

          <div className="card-content-3 ">
            <img
              data-aos="fade-left"
              src={overvalue}
              alt="Skyscrapers"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
      {/* Why Choose Us */}
      <section className="flex flex-col lg:flex-row items-center home-why-choose-us">
        <div className="md:w-1/2 flex justify-center">
          <img data-aos="fade-up" src={workers} alt="Workers" className="" />
        </div>
        <div className="why-choose-us-content">
          <h3
            className="text-gray-500 text-sm uppercase tracking-wider mb-2"
            data-aos="fade-up"
          >
            Why Choose Us
          </h3>
          <h2 data-aos="fade-up" data-aos-delay="300">
            Our commitment to <span className="text-blue-700">safety</span>,{" "}
            <span className="text-blue-700">reliability</span>, and{" "}
            <span className="text-blue-700">time-bound delivery</span> makes us
            the preferred choice for developers, architects, and housing
            societies alike.
          </h2>
          <ul className="space-y-3">
            {[
              "End-to-End Civil Construction",
              "Society Redevelopment & Compliance",
              "RCC & Structural Works",
              "In-house Machinery & Skilled Workforce",
              "Transparent, Ethical Operations",
            ].map((item, index) => (
              <li
                key={index}
                className="list-item-style flex items-start gap-3 text-base text-gray-700"
                data-aos="fade-up"
                data-aos-delay={`${400 + index * 100}`}
              >
                <span className="text-blue-600">
                  <img src={check} alt="Check" />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>
      {/* Projects */}
      <section className="bg-gray-100 project-section-home">
        <div className="pro-content-title">
          <h3
            data-aos="fade-up"
            className="text-gray-600 uppercase tracking-widest"
          >
            Our Projects
          </h3>
          <h2 data-aos="fade-up" className="text-3xl font-bold mb-10">
            From <span>Blueprint</span> to Breakthrough:
          </h2>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            280: {
              slidesPerView: 1.4,
            },
            768: {
              slidesPerView: 2,
            },
            980: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4.5,
            },
          }}
          className="pb-10"
        >
          {sliderImages.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="">
                <img
                  src={image}
                  alt={`Project ${index + 1}`}
                  className="w-full object-cover swiper-img"
                />
                {/* <p className="swiper-para text-sm text-gray-600">
                  Lorem Ipsum dummy text
                </p> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex justify-center mt-8">
          <Link to="/projects">
            <button data-aos="fade-up" className="pro-content-btn">
              View More
            </button>
          </Link>
        </div>
      </section>
      {/* Get in Touch */}
      <section className="bg-[#1C3E9A] text-white px-6 main-cta-card md:px-28">
        <div className="col-flex flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 text-center md:text-left cta-headong">
            <h3 data-aos="fade-up">Get in Touch</h3>
            <h2 data-aos="fade-up">
              Time to take action? <br className="hidden md:block" />
              Get a quote today
            </h2>
            <Link to="/contact">
              <button
                data-aos="fade-up"
                className="uppercase bg-white text-[#1C3E9A] px-6 py-2 mt-6 rounded-full"
              >
                Get a Quote
              </button>
            </Link>
          </div>

          <div className="md:w-1/2 mt-8 md:mt-0 flex justify-center">
            <img
              data-aos="zoom-in-up"
              src={getInTouch}
              alt="Engineers"
              className="h-90 w-100 object-contain"
            />
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Home;
